// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"ballType__gradient-bg5__np7mH"};